var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 6V5a3 3 0 116 0v1h.5a1 1 0 011 1v5a1 1 0 01-1 1h-7a1 1 0 01-1-1V7a1 1 0 011-1h.5zM19 5v1h-3V5a1.5 1.5 0 013 0zm1.5 6.5v-4h-6v4h6z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7 3.5h4.8V5H6.7c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 00-.21.209 1.254 1.254 0 00-.035.242C5.002 5.767 5 6.115 5 6.7v13.343l4.908-3.449.007-.005c.031-.022.104-.073.177-.117a1.75 1.75 0 011.817 0c.072.044.145.095.176.117l.007.005L17 20.042V14.5h1.5v5.35c0 .997 0 1.495-.207 1.764a1 1 0 01-.75.39c-.34.015-.748-.272-1.563-.845l-4.75-3.337c-.083-.059-.124-.088-.17-.099a.251.251 0 00-.12 0c-.046.011-.087.04-.17.099l-4.75 3.337c-.815.573-1.223.86-1.562.845a1 1 0 01-.751-.39c-.207-.27-.207-.767-.207-1.764V6.7c0-1.12 0-1.68.218-2.108a2 2 0 01.874-.874C5.02 3.5 5.58 3.5 6.7 3.5z",
    fill: "currentColor"
  })));
}
export default SvgBookmarkLock;